import { DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, provideNgReflectAttributes } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EditorModule } from '@progress/kendo-angular-editor';
import { IntlModule, IntlService } from '@progress/kendo-angular-intl';
import '@progress/kendo-angular-intl/locales/en-AU/all';
import '@progress/kendo-angular-intl/locales/en-CA/all';
import '@progress/kendo-angular-intl/locales/en-GB/all';
import '@progress/kendo-angular-intl/locales/fr-CA/all';
import '@progress/kendo-angular-intl/locales/id/all';
import '@progress/kendo-angular-intl/locales/en-MY/all';
import '@progress/kendo-angular-intl/locales/en/currencies';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { ANALYTICS_INITIALIZIER_PROVIDER, AuthenticationService, ClCommonAngularModule, CustomIntlService, ExperienceModule, IReleaseNoteService, LOGGER_PROVIDER, LoggerService, TITLE_PROVIDER } from 'cl-common-angular';
import { BlockUIModule } from 'ng-block-ui';
import { ToastrModule } from 'ngx-toastr';
import { AppInterceptors } from './app-interceptors';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './core/data/auth.service';
import { LogService } from './core/data/log.service';
import { ReleaseNoteService } from './core/data/release-note.service';
import { DateSerializerInterceptor } from './shared/interceptors/date-serializer-interceptor.interceptor';

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        BlockUIModule.forRoot(),
        ToastrModule.forRoot({
            closeButton: true,
            positionClass: 'toast-top-center',
            timeOut: 3000
        }),
        IntlModule,
        ScrollViewModule,
        ClCommonAngularModule,
        AppRoutingModule,
        EditorModule,
        ExperienceModule.forRoot({
            experienceUrl: 'https://experience-dev-devinternal.elluciancloud.com',
            headerKitUrl: 'https://experience-dev-devinternal.elluciancloud.com/headerkit/loader.js',
            querySelector: '#experience-controls',
        }),
    ],
    providers: [
        ANALYTICS_INITIALIZIER_PROVIDER,
        AppInterceptors,
        { provide: AuthenticationService, useClass: AuthService },
        { provide: IReleaseNoteService, useClass: ReleaseNoteService },
        { provide: HTTP_INTERCEPTORS, useClass: DateSerializerInterceptor, multi: true },
        DecimalPipe,
        { provide: LoggerService, useClass: LogService },
        { provide: IntlService, useClass: CustomIntlService },
        LOGGER_PROVIDER,
        provideHttpClient(withInterceptorsFromDi()),
        provideNgReflectAttributes(),
        TITLE_PROVIDER
    ],
})
export class AppModule { }
